import styled from "@emotion/styled";
import AudioFileIcon from "@mui/icons-material/AudioFile";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import SendIcon from "@mui/icons-material/Send";
import { Box, Fab, TextField } from "@mui/material";
import { Theme } from "@mui/material/styles/createTheme";
import { shouldForwardProp } from "../common/Common.style";

export const PreviewContainer = styled(Box)`
  flex-direction: column;
  display: flex;
  height: 100%;
  justify-content: space-between;
  position: absolute;
  z-index: 9999;
  background: ${({ theme }) => (theme as Theme).palette.background.default};
  width: 100%;
`;

export const PreviewHeaderContainer = styled(Box)`
  display: flex;
  width: 100%;
  background-color: #5c5c5c;
  padding: 10px;
  align-items: center;
`;

export const CloseIconButton = styled(CloseIcon)`
  color: #fff;
  margin-right: 20px;
  margin-left: 10px;
`;

export const PreviewBodyContainer = styled(Box)`
  flex-direction: column;
  padding: 20px;
  height: calc(100% - 60px);
  width: 100%;
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: space-between;
`;

export const PreviewImage = styled("img")`
  display: flex;
  height: calc(100% - 165px);
  margin-bottom: 10px;
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
`;

export const PreviewVideo = styled("video")`
  display: flex;
  margin-bottom: 10px;
  justify-content: center;
  align-items: center;
  max-height: calc(100% - 165px);
  max-width: calc(100% - 270px);
`;

export const PreviewAudio = styled(Box)`
  display: flex;
  flex: 1;
  align-items: center;
  height: calc(100% - 165px);
  margin-bottom: 10px;
`;

export const PreviewDoc = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  height: calc(100% - 165px);
  margin-bottom: 10px;
`;

export const CAPTION_INPUT_BOTTOM_MARGIN = 32;
export const CAPTION_INPUT_TOP_MARGIN = 10;
export const CAPTION_INPUT_HEIGHT = 48;

export const CaptionInput = styled(TextField)`
  width: 70%;
  margin-top: ${CAPTION_INPUT_TOP_MARGIN}px;
  margin-bottom: ${CAPTION_INPUT_BOTTOM_MARGIN}px;
  height: ${CAPTION_INPUT_HEIGHT}px;
`;

export const ThumbImagesContainer = styled(Box)`
  width: 100%;
  display: flex;
  padding: 10px 20px;
  justify-content: center;
  background-color: #d9d9d9;
  position: relative;
`;

export const SendIconButton = styled(Fab)`
  padding: 10px;
  position: absolute;
  top: -28px;
  right: 40px;
`;

export const SendIconMui = styled(SendIcon)`
  height: 32px;
  width: 32px;
`;

type StyleBoxProps = {
  isSelected?: boolean;
};

export const ThumbnailContainer = styled(Box, {
  shouldForwardProp: prop =>
    shouldForwardProp<StyleBoxProps>(["isSelected"], prop),
})<StyleBoxProps>(({ isSelected }) => ({
  display: "flex",
  width: "85px",
  height: "85px",
  backgroundColor: "#fff",
  position: "relative",
  margin: "2px 5px",
  borderRadius: "4px",
  transform: isSelected ? "scale(1.05)" : undefined,
}));

export const ThumbImage = styled("img")`
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: inherit;
`;

export const RemoveFileIcon = styled(CancelIcon)`
  position: absolute;
  right: 4px;
  top: 4px;
  cursor: pointer;

  &:hover {
    color: rgba(113, 121, 126, 0.9);
  }

  color: rgba(113, 121, 126, 0.5);
`;

export const VideoThumbnail = styled(PlayCircleIcon)`
  position: absolute;
  display: flex;
  width: 100%;
  height: 60%;
  left: 0;
  right: 0;
  align-self: center;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: rgba(113, 121, 126, 0.8);
`;

export const PlaceHolderImageContainer = styled(Box)`
  display: flex;
  width: 85px;
  height: 85px;
  align-self: center;
  background-color: #fff;
  margin: 2px 5px;
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    background-color: #e9f4f8;
  }
`;

export const PreviewLoaderContainer = styled(Box)`
  flex-direction: column;
  display: flex;
  height: 100%;
  justify-content: center;
  border-style: dashed;
  border-width: 3px;
  border-color: #999999;
  margin: 5px;
  border-radius: 2px;
  align-items: center;
`;

export const AudioThumbnail = styled(AudioFileIcon)`
  display: flex;
  align-self: center;
  width: 100%;
  height: 56px;
  color: rgba(113, 121, 126, 0.8);
`;

export const DocThumbnail = styled(Box)`
  display: flex;
  align-self: center;
  width: 100%;
  height: 56px;
`;

export const DocImg = styled.img`
  height: 80px;
  width: 80px;
  margin-right: 20px;
`;
